import { Button } from 'antd';
import { Formik } from 'formik';
import React from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { changedAmountConfig } from '../../../store/config/config.actions';
// import { getConfigAmountSelector } from '../../../store/config/config.selectors';
import { FormikInput } from '../../molecules/formik-input-field';
import { FormWrapper } from './styles';
import { schemaChardeBalance } from './validation';
import { ApiService } from '../../../services';

export const ChangeCurrencyForm = () => {
  const [currentExchange, setCurrentExchange] = React.useState(0)
  React.useEffect(() => test(), [])
  const test = async () => {
    try {
      const { data } = await ApiService.PricingService.getLastCurrency();
      setCurrentExchange(data.data.currencyUSD)
      // console.log(data);
    } catch (error) {
      console.log(error);
    }
  };
  // const dispatch = useDispatch();
  // const currency = useSelector(getConfigAmountSelector);

  const test1 = async (amount) => {
    try {
      const { data } = await ApiService.PricingService.putNewCurrency(amount);
      if (data.statusCode === 201) {
        test();
      }
    } catch (error) {
      console.log(error);
    }
  }; 

  return (
    <Formik
      initialValues={{
        amount: '',
      }}
      enableReinitialize
      onSubmit={({amount}, actions) => {
        test1(amount)
        // dispatch(changedAmountConfig(values, actions.resetForm));
      }}
      validationSchema={schemaChardeBalance}
    >
      {({ isValid, handleSubmit, submitForm }) => (
        <FormWrapper onSubmit={handleSubmit}>
          <h1>Tasa actual: 1 USD = {currentExchange} COP</h1>
          <p className="text-info">Valor del currency</p>
          <FormikInput
            name="amount"
            style={{ width: '100%' }}
            type="number"
            placeholder="Ej: 123abc456def"
          />

          <div className="submit-button">
            <Button
              type="primary"
              ghost
              onClick={submitForm}
              disabled={!isValid}
              block
            >
              Confirmar
            </Button>
          </div>
        </FormWrapper>
      )}
    </Formik>
  );
};
